export default class FooterLinksData {
  static async getAll() {
    const response = await fetch(`/footerLinks.json`);
    const data = await response.json();
    return data;
  }
}
